import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('COMMENT_TO_MODERATE').plugin(axiosPlugin);

let updateCommentsToModerateAction = redux.fetchActionUpdate();
let deleteCommentsToModerateAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const updateCommentToModerate = (type, parentId, commentId, data) => updateCommentsToModerateAction(`/${type}/${parentId}/comments/${commentId}`, data);
export const deleteCommentToModerate = (type, parentId, commentId) => deleteCommentsToModerateAction(`/${type}/${parentId}/comments/${commentId}`);

export const updateStatusCommentToModerate = (userId, type, parentId, commentId, data) => updateCommentsToModerateAction(`users/${userId}/${type}/${parentId}/comments/${commentId}`, data);
export const deleteStatusCommentToModerate = (userId, type, parentId, commentId) => deleteCommentsToModerateAction(`/users/${userId}/${type}/${parentId}/comments/${commentId}`);

export const commentToModerate = redux.reducer();